import { Box, Typography } from '@mui/material';
import React from 'react'
import verified from "../../assets/icons/Verifiedtick.svg";
import { LoadingButton } from '@mui/lab';
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import VenueHeader from "../Venue/VenueHeader";
import useHandleDirectRoute from 'src/hooks/useHandleDirectRoute';

const VerifySuccess = () => { 
  const location = useLocation();
  useHandleDirectRoute(location.state?.redirectedFromBack)
  const queryParams = new URLSearchParams(location.search);
  const verificationType = queryParams.get('verify');
  const redirectPath = location.state?.profilePath;
  const navigate = useNavigate();
  const handleGoBack = () => {
    let orderType = localStorage.getItem("mode");
    if(verificationType == 'Phone' && redirectPath=='profile' ){
      navigate(`/profile`);
    } else if(orderType == 'QrDineIn' || orderType == 'QrPickUp' || orderType == 'carHop' || verificationType == 'Phone' ){
     navigate('/checkout')
    }else{
      navigate(`/venue`);
    }
  };

  const from = location.state?.from || '/';
  return (
    <>
    <VenueHeader />
    <Box marginTop={10}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="5vh"
      >
        <img src={verified} alt="verification" />
      </Box>
      <Typography variant="h3" paragraph>
        Verified
      </Typography>

      <Typography sx={{ color: "text.secondary", mb: 5 }}>
        You have successfully verified your {verificationType=='Phone'?'phone number':verificationType=='Email'?'email address':verificationType}.
      </Typography>
      <LoadingButton
        fullWidth
        onClick={handleGoBack}
        // component={RouterLink}
        // to={'/venue'}
        size="large"
        type="submit"
        variant="contained"
        // loading={isSubmitting}
        sx={{ mt: 3 }}
      >
        Go
      </LoadingButton>
      </Box>
    </>
  );
}

export default VerifySuccess
